import React from 'react'
import moment from 'moment';
import DataTable from 'react-data-table-component';
import queryString from 'query-string';
import PatientsEmpty from './Empty';
import SearchComponent from './SearchFilter';

import { history } from '../../../../_helpers/history';
import { useSelector } from 'react-redux';
import { Button, Spinner } from 'react-bootstrap';

export default function PatientList({ location, collection, isLoading, initLoad, total, selectPatient }) {
  const alert = useSelector(state => state.alert)

  const columns = [
    {
      name: 'First Name',
      sort: false,
      selector: user => user.firstName
    },
    {
      name: 'Last Name',
      sort: false,
      selector: user => user.lastName
    },
    {
      name: 'Date of Birth',
      sort: false,
      width: '160px',
      cell: user => moment(user.dateOfBirth).format('MM/DD/YYYY')
    },
    {
      name: 'Gender',
      sort: false,
      cell: user => user.sexAssignedAtBirth === 'm' ? 'Male' : 'Female'
    },
    {
      name: 'Last Login',
      sort: false,
      cell: user => user.lastLogin ? moment.tz(`${user.lastLogin.date}`, user.lastLogin.timezone).local().format('l') : 'Has not logged in'
    },
    {
      button: true,
      sort: false,
      width: '160px',
      cell: user => {
        return <Button variant='primary' onClick={() => selectPatient(user)}>
          Send Message
        </Button>
      }
    }
  ];

  return (
    <div className="container-lg px-0 mt-4">
      {alert.message &&
        <div className={`alert ${alert.type}`}>{alert.message}</div>
      }

      <div className="col-lg-12">

        <h1 className="h2"><i className="far fa-comment-dots" aria-hidden="true"></i> Messages</h1>
        <p>Search for the patient.</p>

        {initLoad && isLoading ?
          <Spinner animation="border" role="status" />
          :
          initLoad && collection.length === 0 ?
            <PatientsEmpty />
            :
            <div className="card">
              <div className="card-body">
                <DataTable
                  noHeader
                  columns={columns}
                  data={collection}
                  progressPending={isLoading}
                  subHeader
                  subHeaderComponent={<SearchComponent history={history} location={location} />}
                  onChangePage={page => {
                    const queryParams = queryString.parse(location.search);

                    const lastName = queryParams.lastName || '';
                    const firstName = queryParams.firstName || '';
                    const dateOfBirth = queryParams.dateOfBirth || '';

                    history.replace(`/messages/send?page=${page}&firstName=${firstName}&lastName=${lastName}&dateOfBirth=${dateOfBirth}`);
                  }}
                  striped={true}
                  pagination={true}
                  paginationServer={true}
                  paginationTotalRows={total}
                  paginationRowsPerPageOptions={[15]}
                  paginationPerPage={15}
                  noDataComponent={<div className="p-4">We could not find any results based on your search criteria</div>}
                  customStyles={{ 
                    rows: { style: { justifyContent: 'space-between'}, }, 
                    cells: { style: { fontSize: '14px' }, },
                    headRow: { style: { justifyContent: 'space-between'}, }, 
                  }}
                />
              </div>
            </div>
        }
      </div>
    </div>
  )
}
